<template lang="html">
  <div>
    <div class="loader-wrap" v-if="!loaded">
      <div class="loader-content">
        <div class="loader">
          <div class="loader__item"></div>
        </div>
      </div>
    </div>

    <div class="content" v-else>
      <h1>Nastavení</h1>

      <!-- <h2>Doprava</h2>
      <p>
        Hodnota <b>-1</b> znamená, že není nastaveno tj. Doprava zdarma od -1 =
        doprava zdarma není.
      </p>
      <v-layout class="layout--spaced">
        <table class="info-table">
          <tr>
            <td class="info-table__title">Zásilkovna</td>
            <td></td>
          </tr>
          <tr>
            <td class="info-table__title info-table__title--small">
              Cena (Kč):
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--small"
                outlined
                type="number"
                v-model="
                  settings.find((s) => s.type == 'ZASILKOVNA_PRICE').data.price
                "
              >
              </v-text-field>
            </td>
          </tr>
          <tr>
            <td class="info-table__title info-table__title--small">
              Doprava zdarma od (Kč):
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--small"
                outlined
                type="number"
                v-model="
                  settings.find((s) => s.type == 'ZASILKOVNA_PRICE').data
                    .free_from
                "
              >
              </v-text-field>
            </td>
          </tr>
          <tr>
            <td class="info-table__title info-table__title--small">
              Cena (€):
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--small"
                outlined
                type="number"
                v-model="
                  settings.find((s) => s.type == 'ZASILKOVNA_PRICE').data
                    .price_eur
                "
              >
              </v-text-field>
            </td>
          </tr>
          <tr>
            <td class="info-table__title info-table__title--small">
              Doprava zdarma od (€):
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--small"
                outlined
                type="number"
                v-model="
                  settings.find((s) => s.type == 'ZASILKOVNA_PRICE').data
                    .free_from_eur
                "
              >
              </v-text-field>
            </td>
          </tr>
          <tr>
            <td class="info-table__title">Balíkovna</td>
            <td></td>
          </tr>
          <tr>
            <td class="info-table__title info-table__title--small">
              Cena (Kč):
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--small"
                outlined
                type="number"
                v-model="
                  settings.find((s) => s.type == 'BALIKOVNA_PRICE').data.price
                "
              >
              </v-text-field>
            </td>
          </tr>
          <tr>
            <td class="info-table__title info-table__title--small">
              Doprava zdarma od (Kč):
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--small"
                outlined
                type="number"
                v-model="
                  settings.find((s) => s.type == 'BALIKOVNA_PRICE').data
                    .free_from
                "
              >
              </v-text-field>
            </td>
          </tr>
          <tr>
            <td class="info-table__title info-table__title--small">
              Cena (€):
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--small"
                outlined
                type="number"
                v-model="
                  settings.find((s) => s.type == 'BALIKOVNA_PRICE').data
                    .price_eur
                "
              >
              </v-text-field>
            </td>
          </tr>
          <tr>
            <td class="info-table__title info-table__title--small">
              Doprava zdarma od (€):
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--small"
                outlined
                type="number"
                v-model="
                  settings.find((s) => s.type == 'BALIKOVNA_PRICE').data
                    .free_from_eur
                "
              >
              </v-text-field>
            </td>
          </tr>
          <tr>
            <td class="info-table__title">Balíkovna HD</td>
            <td></td>
          </tr>
          <tr>
            <td class="info-table__title info-table__title--small">
              Cena (Kč):
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--small"
                outlined
                type="number"
                v-model="
                  settings.find((s) => s.type == 'BALIKOVNA_HD_PRICE').data
                    .price
                "
              >
              </v-text-field>
            </td>
          </tr>
          <tr>
            <td class="info-table__title info-table__title--small">
              Doprava zdarma od (Kč):
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--small"
                outlined
                type="number"
                v-model="
                  settings.find((s) => s.type == 'BALIKOVNA_HD_PRICE').data
                    .free_from
                "
              >
              </v-text-field>
            </td>
          </tr>
          <tr>
            <td class="info-table__title info-table__title--small">
              Cena (€):
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--small"
                outlined
                type="number"
                v-model="
                  settings.find((s) => s.type == 'BALIKOVNA_HD_PRICE').data
                    .price_eur
                "
              >
              </v-text-field>
            </td>
          </tr>
          <tr>
            <td class="info-table__title info-table__title--small">
              Doprava zdarma od (€):
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--small"
                outlined
                type="number"
                v-model="
                  settings.find((s) => s.type == 'BALIKOVNA_HD_PRICE').data
                    .free_from_eur
                "
              >
              </v-text-field>
            </td>
          </tr>
          <tr>
            <td class="info-table__title">Zásilkovna SK</td>
            <td></td>
          </tr>
          <tr>
            <td class="info-table__title info-table__title--small">
              Cena (Kč):
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--small"
                outlined
                type="number"
                v-model="
                  settings.find((s) => s.type == 'ZASILKOVNA_SK_PRICE').data
                    .price
                "
              >
              </v-text-field>
            </td>
          </tr>
          <tr>
            <td class="info-table__title info-table__title--small">
              Doprava zdarma od (Kč):
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--small"
                outlined
                type="number"
                v-model="
                  settings.find((s) => s.type == 'ZASILKOVNA_SK_PRICE').data
                    .free_from
                "
              >
              </v-text-field>
            </td>
          </tr>
          <tr>
            <td class="info-table__title info-table__title--small">
              Cena (€):
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--small"
                outlined
                type="number"
                v-model="
                  settings.find((s) => s.type == 'ZASILKOVNA_SK_PRICE').data
                    .price_eur
                "
              >
              </v-text-field>
            </td>
          </tr>
          <tr>
            <td class="info-table__title info-table__title--small">
              Doprava zdarma od (€):
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--small"
                outlined
                type="number"
                v-model="
                  settings.find((s) => s.type == 'ZASILKOVNA_SK_PRICE').data
                    .free_from_eur
                "
              >
              </v-text-field>
            </td>
          </tr>
        </table>
      </v-layout> -->

      <h2>Poukazy</h2>
      <v-layout class="layout--spaced">
        <table class="info-table">
          <tr
            v-if="settings.find((setting) => setting.type === 'vouchers_type')"
          >
            <td class="info-table__title">
              Typ poukazu:
            </td>
            <td class="info-table__value">
              <v-select
                :items="voucherTypes"
                v-model="
                  settings.find((setting) => setting.type === 'vouchers_type')
                    .data
                "
                outlined
                item-value="value"
                item-text="text"
                class="input--small"
              ></v-select>
            </td>
          </tr>
        </table>
      </v-layout>

      <h2>Generování</h2>
      <v-layout class="layout--spaced">
        <table class="info-table">
          <tr
            v-if="settings.find((setting) => setting.type === 'vouchers_type')"
          >
            <td class="info-table__title">
              Mód :
            </td>
            <td class="info-table__value">
              <v-select
                :items="downloadModes"
                v-model="
                  settings.find((setting) => setting.type === 'download_mode')
                    .data
                "
                outlined
                item-value="value"
                item-text="name"
                class="input--small"
              ></v-select>
            </td>
          </tr>
        </table>
      </v-layout>

      <h2>Slevy za nákup v %</h2>
      <v-layout class="layout--spaced">
        <table class="info-table">
          <tr v-if="discounts" v-for="discount in discounts">
            <td class="info-table__title">nad {{ discount.cart_price }}Kč</td>
            <td class="info-table__value">
              <v-text-field
                class="input--small"
                outlined
                v-model="discount.percentage"
              >
              </v-text-field>
            </td>
          </tr>
        </table>
      </v-layout>
      <h2>Bannery</h2>
      <v-layout
        class="layout--spaced"
        v-bind:class="{ 'layout--spaced-last': index + 1 === banners.length }"
        v-for="(data, index) in banners"
      >
        <table class="info-table">
          <tr>
            <td class="info-table__title">
              Typ:
            </td>
            <td class="info-table__value">
              <v-text-field
                disabled
                class="input--small"
                outlined
                v-model="data.type"
              >
              </v-text-field>
            </td>
          </tr>
          <tr>
            <td class="info-table__title">
              Banner:
            </td>
            <td class="info-table__value info-table__value--banner">
              <div v-if="!imageUploaded">
                <div class="image image--loader">
                  <div class="loader">
                    <div class="loader__item"></div>
                    <div class="loader__text">Nahrávání</div>
                  </div>
                </div>
              </div>
              <div v-else>
                <img
                  style="max-height: 300px; max-width: 300px"
                  :src="appUrl + 'images/banner/' + data.image"
                />
              </div>

              <div class="image-controls" v-if="imageUploaded">
                <v-btn
                  @click="selectCoverImage(data.id)"
                  v-if="!data.image"
                  color="primary"
                  type="submit"
                  class="button--inputs"
                >
                  Vybrat
                </v-btn>

                <v-btn
                  @click="selectCoverImage(data.id)"
                  v-if="data.image"
                  color="secondary"
                  type="submit"
                  class="button--inputs"
                >
                  Vybrat jiný
                </v-btn>
              </div>
              <div class="info-table__hint">
                Doporučený rozměr: 792 × 340 px
              </div>
            </td>
          </tr>
          <tr>
            <td class="info-table__title">
              Alt:
            </td>
            <td class="info-table__value">
              <v-text-field class="input--largest" outlined v-model="data.alt">
              </v-text-field>
            </td>
          </tr>
          <tr>
            <td class="info-table__title">
              Odkaz:
            </td>
            <td class="info-table__value">
              <v-text-field class="input--largest" outlined v-model="data.link">
              </v-text-field>
            </td>
          </tr>
          <tr>
            <td class="info-table__title">
              Zobrazit:
            </td>
            <td class="info-table__value">
              <v-checkbox
                class="input--smaller"
                outlined
                v-model="data.enabled"
              >
              </v-checkbox>
            </td>
          </tr>

          <!-- <tr>
                        <td class="info-table__title">
                            Klíčová slova:
                        </td>
                        <td class="info-table__value">
                            <v-text-field
                                    class="input&#45;&#45;larger"
                                    outlined
                                    @input="errors.seo_keywords = ''"
                                    v-model="data.seo_keywords"
                                    :error-messages="makeError(errors.seo_keywords)"
                            >
                            </v-text-field>
                        </td>
                    </tr>-->
        </table>
      </v-layout>
      <v-layout>
        <div class="controls-table">
          <v-btn
            color="primary"
            type="submit"
            class="button--control"
            @click="editSettings()"
          >
            Uložit
          </v-btn>
        </div>
      </v-layout>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Settings',
  components: {},

  data() {
    return {
      voucherTypes: [
        {
          text: 'Klasický',
          value: 'normal',
        },
        {
          text: 'Vánoční',
          value: 'christmas',
        },
      ],
      downloadModes: [
        {
          value: 'default',
          name: 'Klasický',
        },
        {
          value: 'fast',
          name: 'Bez generování',
        },
      ],
      loaded: false,
      banners: [],
      errors: {},
      imageUploaded: true,
      settings: {},
      discounts: [],
        appUrl: ''
    };
  },

  created() {
    this.fetchData();
    const vm = this;
    this.$root.$on('upload-banner-image', (id) => {
      vm.imageUploaded = false;
      vm.$forceUpdate();
    });
    this.$root.$on('uploaded-banner-image', (response) => {
      console.log('RESPONSE', response);
      vm.banners.find((item) => item.id == response.id).image = response.name;
      vm.imageUploaded = true;
      vm.$forceUpdate();
    });
  },
  computed: {
    ...mapState(['profile']),
  },
  mounted() {
      this.appUrl = process.env.VUE_APP_URL
  },
  methods: {
    fetchData() {
      this.$axios
        .get('/admin/settings')
        .then((response) => {
          this.banners = response.data.banners;
          let settings = [];
          // this.settings = response.data.settings;
          for (const i of response.data.settings) {
            if (
              [
                'BALIKOVNA_HD_PRICE',
                'BALIKOVNA_PRICE',
                'ZASILKOVNA_PRICE',
                'ZASILKOVNA_SK_PRICE',
              ].includes(i.type)
            ) {
              try {
                let fi = JSON.parse(JSON.stringify(i));
                fi.data = JSON.parse(Buffer.from(i.data, 'base64').toString());
                settings.push(fi);
              } catch (error) {
                console.error(error);
              }
            } else {
              settings.push(i);
            }
          }
          this.settings = settings;
          this.discounts = response.data.discounts;
          this.loaded = true;
        })
        .catch((e) => {
          this.loaded = true;
        });
    },
    editSettings() {
      this.loaded = false;

      let settings = [];

      for (const i of this.settings) {
        if (
          [
            'BALIKOVNA_HD_PRICE',
            'BALIKOVNA_PRICE',
            'ZASILKOVNA_PRICE',
            'ZASILKOVNA_SK_PRICE',
          ].includes(i.type)
        ) {
          try {
            let fi = JSON.parse(JSON.stringify(i));
            fi.data.price = Number(fi.data.price);
            fi.data.price_eur = Number(fi.data.price_eur);
            fi.data.free_from = Number(fi.data.free_from);
            fi.data.free_from_eur = Number(fi.data.free_from_eur);
            fi.data = Buffer.from(JSON.stringify(fi.data)).toString('base64');
            settings.push(fi);
          } catch (error) {
            console.error(error);
          }
        } else {
          settings.push(i);
        }
      }

      var request = {
        banners: this.banners,
        // settings: this.settings,
        settings: settings,
        discounts: this.discounts,
      };

      console.log(request);

      this.$axios
        .post('/admin/settings', request)
        .then((response) => {
          this.fetchData();
        })
        .catch((e) => {
          this.fetchData();
        });
    },

    selectCoverImage(id) {
      this.$root.$emit('select-banner-image', id);
    },
  },
  watch: {},
};
</script>

<style lang="scss">
.info-table__title--small {
  font-size: 15px !important;
}

.info-table__hint {
  margin-top: 8px;
  font-size: 13px;
  color: #999;
}
</style>
